import { Icon } from "@chakra-ui/react";
import React from "react";

/**
 * Renders the bullet numbers icon
 * 
 * @param {Object} props - The props of the component
 * @returns The bullet numbers icon
 */
const BulletNumbersIcon = (props) => (
  <Icon viewBox="0 0 12 14" {...props}>
    <path d="M0 13.6668V12.6668H1.66667V12.1668H0.666667V11.1668H1.66667V10.6668H0V9.66683H2C2.18889 9.66683 2.34722 9.73072 2.475 9.8585C2.60278 9.98627 2.66667 10.1446 2.66667 10.3335V11.0002C2.66667 11.1891 2.60278 11.3474 2.475 11.4752C2.34722 11.6029 2.18889 11.6668 2 11.6668C2.18889 11.6668 2.34722 11.7307 2.475 11.8585C2.60278 11.9863 2.66667 12.1446 2.66667 12.3335V13.0002C2.66667 13.1891 2.60278 13.3474 2.475 13.4752C2.34722 13.6029 2.18889 13.6668 2 13.6668H0ZM0 9.00016V7.16683C0 6.97794 0.0638889 6.81961 0.191667 6.69183C0.319444 6.56405 0.477778 6.50016 0.666667 6.50016H1.66667V6.00016H0V5.00016H2C2.18889 5.00016 2.34722 5.06405 2.475 5.19183C2.60278 5.31961 2.66667 5.47794 2.66667 5.66683V6.8335C2.66667 7.02238 2.60278 7.18072 2.475 7.3085C2.34722 7.43627 2.18889 7.50016 2 7.50016H1V8.00016H2.66667V9.00016H0ZM1 4.3335V1.3335H0V0.333496H2V4.3335H1ZM4 11.6668V10.3335H12V11.6668H4ZM4 7.66683V6.3335H12V7.66683H4ZM4 3.66683V2.3335H12V3.66683H4Z" fill="currentColor" />
  </Icon>
);

export default React.memo(BulletNumbersIcon);
